import React, { useEffect, useState } from "react"
// import { useDrag } from "react-dnd"
import { T配車, T車輌乗務員 } from "../../../../service/order/haisya/THaisya"
// import { ItemType } from "../HaisyaRegister"
import * as wjcCore from "@grapecity/wijmo"
import { DEFAULT_CARD_CLASS, set配車CardClass } from "../haisyaRegisterUtil"
import util from "../../../../ts/util"

/**
 * 玄関配車
 * @param props
 * @returns
 */
const MonthlyHaisyaTableCard: React.FC<{
  zyomuin: T車輌乗務員
  haisya: T配車[]
  date: string
  chip: string
}> = (props) => {
  const [showIndex, setShowIndex] = useState(0)
  const [className, setClassName] = useState(DEFAULT_CARD_CLASS)
  const [show配車, setShow配車] = useState<T配車>()
  // 設定された配車情報が積日と卸日の中間の配車中であるかのフラグ
  //const [is配送中, setIs配送中] = useState(false)

  // const [
  //   { isDragging },
  //   dragRef,
  //   //    dragPreviewRef
  // ] = useDrag(
  //   () => ({
  //     type: ItemType.配車日単位,
  //     item: () => {
  //       //TODO: 月単位の場合、全件移動する
  //       return { 積日: props.date, 受注配車: props.haisya }
  //     },
  //     collect: (c) => ({ isDragging: c.isDragging() }),
  //   }),
  //   [props.haisya, props.zyomuin]
  // )
  // const opacity = isDragging ? 0.4 : 1

  const changeIndex: React.MouseEventHandler<HTMLSpanElement> = (_e) => {
    if (showIndex === props.haisya.length - 1) {
      setShowIndex(0)
    } else {
      setShowIndex(showIndex + 1)
    }
  }

  useEffect(() => {
    if (props.haisya.length < showIndex + 1) return
    const new配車情報 = props.haisya[showIndex]
    setShow配車(new配車情報)

    const [
      addClassName,
      //  配送中フラグ
    ] = set配車CardClass(props.zyomuin, new配車情報, props.date)
    // setIs配送中(配送中フラグ)
    setClassName(
      util.addTextWithStartDelimiter(DEFAULT_CARD_CLASS, addClassName)
    )
  }, [props.haisya, showIndex, props.zyomuin, props.date])

  return (
    <div
      // ref={dragRef}
      className={className}
      // style={{
      //   opacity,
      //   cursor: isDragging ? "grabbing" : "grab",
      // }}
    >
      {show配車 && (
        <table className="haisya-info-inner">
          <tbody>
            {/* {isDragging && <>ドラッグ中</>} */}
            <tr>
              <td>{show配車.荷主名}</td>
            </tr>
            <tr>
              <td>{show配車.積地市区町村}</td>
            </tr>
            <tr>
              <td>{show配車.卸地市区町村}</td>
            </tr>
            <tr>
              <td>
                {props.chip === "1" && <span>{show配車.品名}</span>}
                {props.chip === "2" && (
                  <span className="text-danger fw-bold">
                    {show配車.食事手当 != null &&
                      wjcCore.format("{食事手当:G}", show配車)}
                    {show配車.食事手当 && "円"}
                  </span>
                )}
              </td>
            </tr>

            <tr>
              <td>
                {props.haisya.length > 1 && (
                  <>
                    <span
                      className="fw-bold text-decoration-underline "
                      onClick={changeIndex}
                      style={{ cursor: "pointer" }}>
                      {showIndex + 1}
                    </span>
                    /{props.haisya.length}件
                  </>
                )}
              </td>
            </tr>
          </tbody>
        </table>
      )}
    </div>
  )
}
export default MonthlyHaisyaTableCard
